import { createAction, props } from '@ngrx/store';
import { Organization } from './organization.model';

export const fetchOrganizations = createAction('[Organizations]: Fetch organizations');
export const fetchOrganizationsSuccess = createAction(
    '[Organizations]: Fetch organizations succeeded',
    props<{
        organizations: Organization[];
    }>()
);
export const fetchOrganizationsFailed = createAction(
    '[Organizations]: Fetch organizations failed',
    props<{ error: Error }>()
);

export const selectOrganization = createAction(
    '[Organizations]: Select organization',
    props<{
        organizationId: string;
    }>()
);

export const fetchOrganizationsByIds = createAction(
    '[Organizations]: Fetch organizations by IDs',
    props<{
        organizationIds: number[];
    }>()
);

export const fetchOrganizationsByIdsSuccess = createAction(
    '[Organizations]: Fetch organizations by IDs succeeded',
    props<{
        organizations: Organization[];
    }>()
);

export const fetchOrganizationsByIdsFailed = createAction(
    '[Organizations]: Fetch organizations by IDs failed',
    props<{ error: Error }>()
);
